export function predictEscalation(trend) {
  if (!trend || trend.length < 4) return null;

  const last = trend.slice(-4);

  const rising =
    last[3] > last[2] &&
    last[2] > last[1] &&
    last[1] > last[0];

  if (rising) {
    return {
      earlyWarning: true,
      message: "Rapid rise detected � potential exposure developing",
    };
  }

  return {
    earlyWarning: false,
  };
}
